module.exports = __webpack_public_path__ + "static/media/spw-global-high-quality.02d25fc8.csv";